<script setup lang="ts"></script>

<template>
  <div class="flex w-full justify-center">
    <div class="flex h-full flex-col items-center justify-center gap-[24px] text-center text-black dark:text-gray-500">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 22 22" fill="none" class="rotate">
        <path
          class="stroke-black dark:stroke-white"
          d="M20.5832 11C20.5832 16.2927 16.2926 20.5834 10.9998 20.5834C5.70711 20.5834 1.4165 16.2927 1.4165 11C1.4165 5.70729 5.70711 1.41669 10.9998 1.41669"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <h2>Uploading</h2>
      <p class="text-content-m">
        Please wait a moment, the content <br />
        is still uploading...
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
